export interface ServerResponse {
    code: number;
    data: any;
    message: string;
}

export function catChuoi(value: string, number: number) {
    const valueStr: string = value;
    return valueStr.substring(0, number);
}

export function layTen(value: string) {
  const valueStr: string = value;
  var words = value.split('.')
  return words[words.length-1];
}

export function TPCloud_isNumber(num, targetLength) {
  if (num) {
    return num.toString().padStart(targetLength, 0);
  }
}


export function TPCloud_getFormatDate() {
  const today = new Date();
  let dd: any = today.getDate();
  let mm: any = today.getMonth() + 1;

  const yyyy = today.getFullYear();
  if (dd < 10) {
    dd = '0' + dd;
  }

  if (mm < 10) {
    mm = '0' + mm;
  }

  return dd + '/' + mm + '/' + yyyy;
}



// WEBPACK FOOTER //
// ./src/app/models/types.ts